import apiCall from './apiCall';

const getAllMenus = async (param: any) => {
    const query = `?search=${param.search || ''}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/Menus/GetAllMenus${query}`;
    return apiCall('get', URL);
};

const getMenuById = async (id: string) => {
    const URL = `/Menus/GetMenuById/${id}`;
    return apiCall('get', URL);
};

const postMenu = async (data: any) => {
    const URL = '/Menus/Create';
    return apiCall('post', URL, data);
};

const putMenu = async (data: any) => {
    const URL = '/Menus/Update';
    return apiCall('post', URL, data);
};

const deleteMenu = async (data: any) => {
    const URL = '/Menus/Delete';
    return apiCall('post', URL, data);
};

export {
    getAllMenus,
    getMenuById,
    postMenu,
    putMenu,
    deleteMenu,
};
